import React from 'react'
import { Box, IconButton, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const MONTH_NAMES = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
]

function getPeriodLabel(period, date) {
    const year = date.getFullYear()
    const month = date.getMonth()

    switch (period) {
        case 'month':
            return `${MONTH_NAMES[month]} ${year}`
        case 'quarter': {
            const q = Math.floor(month / 3) + 1
            return `${q}º Tri ${year}`
        }
        case 'semester': {
            const s = Math.floor(month / 6) + 1
            return `${s}º Sem ${year}`
        }
        case 'year':
        default:
            return `${year}`
    }
}

function stepDate(period, date, direction) {
    const d = new Date(date)
    switch (period) {
        case 'month':
            d.setMonth(d.getMonth() + direction)
            break
        case 'quarter':
            d.setMonth(d.getMonth() + direction * 3)
            break
        case 'semester':
            d.setMonth(d.getMonth() + direction * 6)
            break
        case 'year':
            d.setFullYear(d.getFullYear() + direction)
            break
        default:
            break
    }
    return d
}

function snapToPeriodStart(period, date) {
    const d = new Date(date)
    switch (period) {
        case 'month':
            d.setDate(1)
            break
        case 'quarter':
            d.setMonth(Math.floor(d.getMonth() / 3) * 3, 1)
            break
        case 'semester':
            d.setMonth(Math.floor(d.getMonth() / 6) * 6, 1)
            break
        case 'year':
            d.setMonth(0, 1)
            break
        default:
            break
    }
    return d
}

export default function PeriodNavigator({ period, onPeriodChange, referenceDate, onReferenceDateChange }) {
    const handlePeriodChange = (_, newPeriod) => {
        if (newPeriod) {
            onPeriodChange(newPeriod)
            onReferenceDateChange(snapToPeriodStart(newPeriod, referenceDate))
        }
    }

    const handlePrev = () => onReferenceDateChange(stepDate(period, referenceDate, -1))
    const handleNext = () => onReferenceDateChange(stepDate(period, referenceDate, 1))

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 2,
            }}
        >
            <ToggleButtonGroup
                value={period}
                exclusive
                onChange={handlePeriodChange}
                size="small"
                sx={{
                    bgcolor: '#fff',
                    '& .MuiToggleButton-root': {
                        textTransform: 'none',
                        px: 2,
                        py: 0.5,
                        fontSize: '13px',
                        fontWeight: 500,
                        color: '#64748B',
                        borderColor: '#E2E8F0',
                        '&.Mui-selected': {
                            bgcolor: '#1565C0',
                            color: '#fff',
                            '&:hover': { bgcolor: '#0D47A1' },
                        },
                    },
                }}
            >
                <ToggleButton value="month">Mês</ToggleButton>
                <ToggleButton value="quarter">Trimestre</ToggleButton>
                <ToggleButton value="semester">Semestre</ToggleButton>
                <ToggleButton value="year">Ano</ToggleButton>
            </ToggleButtonGroup>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconButton
                    onClick={handlePrev}
                    size="small"
                    sx={{ bgcolor: '#fff', border: '1px solid #E2E8F0', '&:hover': { bgcolor: '#F1F5F9' } }}
                >
                    <ChevronLeft sx={{ color: '#64748B' }} />
                </IconButton>
                <Typography
                    sx={{
                        minWidth: 160,
                        textAlign: 'center',
                        fontWeight: 600,
                        fontSize: '14px',
                        color: '#1E293B',
                    }}
                >
                    {getPeriodLabel(period, referenceDate)}
                </Typography>
                <IconButton
                    onClick={handleNext}
                    size="small"
                    sx={{ bgcolor: '#fff', border: '1px solid #E2E8F0', '&:hover': { bgcolor: '#F1F5F9' } }}
                >
                    <ChevronRight sx={{ color: '#64748B' }} />
                </IconButton>
            </Box>
        </Box>
    )
}
